/* ez-size-chart.js — Ban-61 → 63 (§58): the size guide.
   Data: snippets/ez-size-chart-data.liquid (#ezSizeData), from Shopify admin › Content › Metaobjects › EZ Size chart.
   - The chart is picked for the STYLE the customer has chosen, from the Teeinblue base of the chosen variant (read from
     the campaign data Teeinblue loads on the page, as in ez-delivery.js):
       1. an EZ Size chart entry listing that base id (Teeinblue IDs),
       2. the EZ Size chart entry whose keyword is the longest match in the base's label + title,
       3. Ban-63: the printer's own size table written in the base's description (Printbelle: "US SIZE | 1/2 BUST |
          LENGTH…" with Inch and Cm columns) — read as it is, nothing to type. Ban-69: only a CLOTHING table (a body
          measure among its columns: bust / chest / waist / hip / sleeve / shoulder / crotch…). Printbelle writes the
          same kind of table for objects (ornaments, pillows, metal signs, flags, candles…: width / length / height
          only), which showed a "Size guide" on 72 bases (~487 products, store scan 17/10),
       4. nothing → no button (blankets, posters, canvas…, or a base nobody has a table for).
     No Teeinblue data → the "Available Product" value against the keywords.
   - Ban-63: the popup is its own layer, built ONCE when the page is idle and then only shown / hidden with a class.
     On this theme every element added to or removed from the page costs 15–60 ms (about a hundred `body:has(…)`
     rules in the theme's CSS are checked again), while a class change inside the popup costs ~0 ms. So: opening,
     closing, inches ⇄ cm and switching styles never add or remove anything; the page behind is never re-laid out
     (no class on <html>: the backdrop and the sheet hold touch / wheel themselves).
     Phones: a sheet from the bottom that follows the finger (pull down to close), Android / browser Back closes it.
     Computers: a centred card. Esc, the backdrop and × close it everywhere; focus stays inside while open.
   - Table first, the chosen size highlighted, one inches / cm switch (US: inches, elsewhere cm, the customer's choice
     is remembered); styles with their own chart (Tee | Hoodie | Sweatshirt) as chips, all tables stacked in one
     place so the sheet never jumps in height; "How to measure" folded below.
   - While this runs, the old chart (size_chart by product tag: "Size Chart" link + modal) is hidden.
   - Owner's checks: ?ez_size_check=1 (this product), ?ez_size_check=all (Ban-62: every base of the store). */
(function () {
  var el = document.getElementById("ezSizeData");
  if (!el || window.__ezSizeChart) return;
  var D;
  try { D = JSON.parse(el.textContent); } catch (e) { return; }
  if (!D || !D.charts || !D.product) return;
  window.__ezSizeChart = true;
  var qs = new URLSearchParams(location.search);
  var CHECK = qs.get("ez_size_check") === "1";
  var SCAN = qs.get("ez_size_check") === "all";
  document.documentElement.classList.add("ez-sg-on");

  /* ---------- styles (Design System: text #1d1d1f, teal #02aeb8 / text #0b7f89 / light #e9f8f9, border #e5e5e5) ---------- */
  var st = document.createElement("style");
  st.textContent = [
    "html.ez-sg-on .js-btn-show-size-chart, html.ez-sg-on .modal-size-chart { display: none !important; }",
    ".ez-sg-host { display: flex !important; align-items: center; justify-content: space-between; gap: 8px; }",
    "/* Ban-72: the link takes no height of its own (-4px above and below), so the Size row is the same height with or\n   without it: Teeinblue redraws the row when the style changes and the form below no longer bobs by 6 px */\n" +
    ".ez-sg-btn { display: inline-flex; align-items: center; gap: 5px; margin: -4px 0 -4px auto; padding: 4px 2px; border: 0; background: none; border-radius: 6px;",
    "  color: #0b7f89; font: inherit; font-size: 14px; font-weight: 500; line-height: 20px; text-transform: none; letter-spacing: 0;",
    "  text-decoration: underline; text-underline-offset: 3px; cursor: pointer; white-space: nowrap; -webkit-tap-highlight-color: transparent; transition: opacity .12s; }",
    ".ez-sg-btn:focus:not(:focus-visible) { outline: 0; box-shadow: none; }",
    "@media (hover: hover) { .ez-sg-btn:hover { color: #02aeb8; } }",
    ".ez-sg-btn:focus-visible { outline: 2px solid #02aeb8; outline-offset: 2px; }",
    ".ez-sg-btn svg { width: 18px; height: 18px; flex: none; }",

    /* the layer: always in the page, invisible and click-through until opened */
    ".ez-sgs { position: fixed; inset: 0; z-index: 2147483646; display: flex; align-items: center; justify-content: center; padding: 16px;",
    "  visibility: hidden; pointer-events: none; transition: visibility 0s linear .3s; font-family: inherit; color: #1d1d1f; letter-spacing: 0; }",
    ".ez-sgs.is-open { visibility: visible; pointer-events: auto; transition-delay: 0s; }",
    ".ez-sgs__bg { position: absolute; inset: 0; background: rgba(17, 17, 17, .5); opacity: 0; transition: opacity .22s ease; touch-action: none; cursor: pointer; }",
    ".ez-sgs.is-open .ez-sgs__bg { opacity: 1; transition-duration: .28s; }",
    ".ez-sgs__card { position: relative; display: flex; flex-direction: column; width: min(480px, 100%); max-height: min(86vh, 760px); max-height: min(86dvh, 760px);",
    "  background: #fff; border-radius: 18px; box-shadow: 0 24px 64px rgba(0, 0, 0, .22); outline: none; overflow: hidden;",
    "  opacity: 0; transform: translate3d(0, 10px, 0) scale(.98); transition: opacity .16s ease, transform .2s ease; will-change: transform; contain: layout paint; }",
    ".ez-sgs.is-open .ez-sgs__card { opacity: 1; transform: none; transition: opacity .2s ease, transform .3s cubic-bezier(.2, .9, .25, 1); }",
    ".ez-sgs__head { flex: none; position: relative; padding: 18px 60px 12px 20px; touch-action: none; }",
    ".ez-sgs__t { margin: 0; font-size: 18px; line-height: 24px; font-weight: 700; color: #1d1d1f; letter-spacing: -.01em; text-transform: none; }",
    ".ez-sgs__sub { margin: 2px 0 0; font-size: 13px; line-height: 18px; color: #6b6b6b; }",
    ".ez-sgs__x { position: absolute; top: 10px; right: 10px; width: 36px; height: 36px; display: grid; place-items: center; margin: 0; padding: 0; border: 0;",
    "  border-radius: 50%; background: #f2f2f2; color: #1d1d1f; cursor: pointer; transition: background .15s, transform .12s; -webkit-tap-highlight-color: transparent; }",
    ".ez-sgs__x:active { transform: scale(.92); }",
    "@media (hover: hover) { .ez-sgs__x:hover { background: #e5e5e5; } }",
    ".ez-sgs__x svg { width: 16px; height: 16px; }",
    ".ez-sgs :focus { outline: 0 !important; box-shadow: none !important; }",
    ".ez-sgs.is-kbd [tabindex]:focus-visible, .ez-sgs.is-kbd summary:focus-visible { outline: 2px solid #02aeb8; outline-offset: 2px; }",
    ".ez-sgs__body { flex: 1 1 auto; min-height: 0; overflow-y: auto; overscroll-behavior: contain; -webkit-overflow-scrolling: touch; padding: 0 20px 20px; }",
    ".ez-sgs__chips { display: flex; gap: 8px; margin: 0 -20px 14px; padding: 2px 20px; overflow-x: auto; scrollbar-width: none; overscroll-behavior-x: contain; }",
    ".ez-sgs__chips::-webkit-scrollbar { display: none; }",
    ".ez-sgs__chip, .ez-sgs__x, .ez-sg-btn { -webkit-user-select: none; user-select: none; }",
    ".ez-sgs__chips { -webkit-mask-image: linear-gradient(90deg, transparent 0, #000 20px, #000 calc(100% - 20px), transparent); mask-image: linear-gradient(90deg, transparent 0, #000 20px, #000 calc(100% - 20px), transparent); }",
    ".ez-sgs__chip { flex: none; padding: 7px 16px; border: 1px solid #e5e5e5; border-radius: 999px; background: #fff; color: #1d1d1f; font: inherit; font-size: 13px; line-height: 18px; font-weight: 500;",
    "  cursor: pointer; transition: background .15s, border-color .15s, color .15s; -webkit-tap-highlight-color: transparent; }",
    ".ez-sgs__chip[aria-selected=true] { border-color: #02aeb8; background: #e9f8f9; color: #0b7f89; box-shadow: inset 0 0 0 .5px #02aeb8; }",
    ".ez-sgs__bar { display: flex; align-items: center; justify-content: space-between; gap: 12px; margin: 0 0 12px; }",
    ".ez-sgs__cap { display: flex; align-items: center; gap: 6px; margin: 0; min-width: 0; font-size: 13px; line-height: 18px; color: #6b6b6b; }",
    ".ez-sgs__cap svg { flex: none; width: 16px; height: 16px; color: #0b7f89; }",
    /* inches / cm: a segmented switch whose white thumb slides */
    ".ez-sgs__unit { position: relative; display: inline-grid; grid-template-columns: 1fr 1fr; flex: none; padding: 3px; border-radius: 999px; background: #f2f2f2; }",
    ".ez-sgs__unit::before { content: ''; position: absolute; top: 3px; bottom: 3px; left: 3px; width: calc(50% - 3px); border-radius: 999px; background: #fff;",
    "  box-shadow: 0 1px 3px rgba(0, 0, 0, .14); transition: transform .22s cubic-bezier(.2, .9, .25, 1); }",
    ".ez-sgs.is-cm .ez-sgs__unit::before { transform: translateX(100%); }",
    ".ez-sgs__unit [data-u] { position: relative; display: block; width: 64px; user-select: none; -webkit-user-select: none; padding: 6px 0; border: 0; background: none !important; color: #9b9b9b !important; font: inherit; font-size: 13px; line-height: 18px;",
    "  font-weight: 600; letter-spacing: 0; text-align: center; cursor: pointer; transition: color .2s; -webkit-tap-highlight-color: transparent; }",
    ".ez-sgs:not(.is-cm) .ez-sgs__unit [data-u=in], .ez-sgs.is-cm .ez-sgs__unit [data-u=cm] { color: #1d1d1f !important; }",
    /* every style's table in the same grid cell: the tallest one sets the height, switching only cross-fades */
    ".ez-sgs__panels { display: grid; align-items: start; overflow: hidden; transition: height .24s cubic-bezier(.2, .9, .25, 1); }",
    ".ez-sgs__panel { grid-area: 1 / 1; min-width: 0; opacity: 0; visibility: hidden; transition: opacity .16s ease, visibility 0s linear .16s; }",
    ".ez-sgs__panel.is-on { opacity: 1; visibility: visible; transition-delay: 0s; }",
    ".ez-sgs__seg { margin: 14px 0 6px; font-size: 13px; font-weight: 600; color: #404040; }",
    ".ez-sgs__seg:first-child { margin-top: 0; }",
    ".ez-sgs__wrap { overflow-x: auto; border: 1px solid #ececec; border-radius: 14px; background: #fff; }",
    /* the theme styles every table (borders on all sides, padding 5px !important): ours wins with its own class */
    ".ez-sgs table.ez-sgs__tbl { width: 100%; margin: 0; border: 0; border-collapse: collapse; table-layout: fixed; font-size: 14px; line-height: 20px; font-variant-numeric: tabular-nums; }",
    ".ez-sgs table.ez-sgs__tbl th, .ez-sgs table.ez-sgs__tbl td { padding: 12px 4px !important; border: 0 !important; border-bottom: 1px solid #f2f2f2 !important; text-align: center; vertical-align: middle;",
    "  font-weight: 400; color: #1d1d1f; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; letter-spacing: 0; background: none; }",
    ".ez-sgs table.ez-sgs__tbl thead th { padding: 10px 4px !important; background: #f8f8f8; font-size: 11px; line-height: 14px; font-weight: 600; color: #8a8a8a; white-space: normal; text-transform: uppercase; letter-spacing: .06em; }",
    ".ez-sgs table.ez-sgs__tbl tbody th { font-weight: 600; }",
    ".ez-sgs table.ez-sgs__tbl tbody tr:last-child > * { border-bottom: 0 !important; }",
    ".ez-sgs table.ez-sgs__tbl tr.is-on > * { background: #e9f8f9; color: #0b7f89; font-weight: 700; }",
    ".ez-sgs table.ez-sgs__tbl tr.is-on > th { box-shadow: inset 3px 0 0 #02aeb8; }",
    ".ez-sgs .ez-c { display: none; } .ez-sgs.is-cm .ez-c { display: inline; } .ez-sgs.is-cm .ez-i { display: none; }",
    ".ez-sgs__notes { display: grid; gap: 6px; margin: 12px 2px 0; }",
    ".ez-sgs__note { display: flex; gap: 8px; margin: 0; color: #6b6b6b; font-size: 13px; line-height: 18px; }",
    ".ez-sgs__note svg { flex: none; width: 16px; height: 16px; margin-top: 1px; color: #0b7f89; }",
    ".ez-sgs__tip { color: #1d1d1f; }",
    ".ez-sgs__how { margin: 16px 0 0; border-top: 1px solid #f0f0f0; }",
    ".ez-sgs__how summary { display: flex; align-items: center; justify-content: space-between; padding: 14px 0 2px; font-size: 14px; font-weight: 600; cursor: pointer; list-style: none; }",
    ".ez-sgs__how summary::-webkit-details-marker { display: none; }",
    ".ez-sgs__how summary svg { width: 16px; height: 16px; color: #0b7f89; transition: transform .2s; }",
    ".ez-sgs__how[open] summary svg { transform: rotate(180deg); }",
    ".ez-sgs__how img { display: block; width: 100%; max-width: 420px; height: auto; margin: 10px auto 0; aspect-ratio: 3 / 2; object-fit: contain; }",
    /* phones: a sheet from the bottom with a grab handle */
    "@media (max-width: 749px) {",
    "  .ez-sgs { align-items: flex-end; padding: 0; }",
    "  .ez-sgs__card { width: 100%; max-height: 88vh; max-height: 88dvh; border-radius: 18px 18px 0 0; padding-bottom: env(safe-area-inset-bottom);",
    "    opacity: 1; transform: translate3d(0, 100%, 0); transition: transform .22s cubic-bezier(.4, 0, .7, .2); box-shadow: 0 -8px 32px rgba(0, 0, 0, .16); }",
    "  .ez-sgs.is-open .ez-sgs__card { transform: translate3d(0, 0, 0); transition: transform .36s cubic-bezier(.32, .72, 0, 1); }",
    "  .ez-sgs__head { padding: 24px 60px 12px 16px; }",
    "  .ez-sgs__head::before { content: ''; position: absolute; top: 8px; left: 50%; width: 38px; height: 5px; margin-left: -19px; border-radius: 3px; background: #d9d9d9; }",
    "  .ez-sgs__x { top: 14px; }",
    "  .ez-sgs__body { padding: 0 16px 18px; }",
    "  .ez-sgs__chips { margin: 0 -16px 14px; padding: 2px 16px; }",
    "}",
    "@media (prefers-reduced-motion: reduce) { .ez-sgs__bg, .ez-sgs__card, .ez-sgs__panel, .ez-sgs__unit::before { transition-duration: .01s !important; } }",

    ".ez-sg-check { position: fixed; left: 8px; bottom: 8px; z-index: 2147483000; max-width: min(460px, calc(100vw - 16px)); max-height: 60vh; overflow: auto;",
    "  padding: 10px 12px; background: #fff; border: 2px solid #0b7f89; border-radius: 8px; box-shadow: 0 4px 16px rgba(0,0,0,.2); font: 12px/1.45 system-ui, sans-serif; color: #1d1d1f; }",
    ".ez-sg-scan { left: 50%; transform: translateX(-50%); bottom: auto; top: 8px; max-width: min(1100px, calc(100vw - 16px)); width: 100%; max-height: calc(100vh - 16px); }",
    ".ez-sg-scan table { width: 100%; border-collapse: collapse; margin-top: 8px; } .ez-sg-scan th, .ez-sg-scan td { padding: 4px 6px; border-bottom: 1px solid #eee; text-align: left; vertical-align: top; }",
    ".ez-sg-scan thead th { position: sticky; top: -10px; background: #fafafa; } .ez-sg-scan tr.bad td { background: #fdecea; color: #1d1d1f; } .ez-sg-scan small { color: #666; }",
    ".ez-sg-csv { margin-left: 6px; padding: 3px 10px; border: 1px solid #0b7f89; border-radius: 6px; background: #fff; color: #0b7f89; font: inherit; cursor: pointer; }",
    ".ez-sg-check b { color: #0b7f89; } .ez-sg-check .bad { color: #c62828; } .ez-sg-check ul { margin: 4px 0; padding-left: 16px; }"
  ].join("\n");
  (document.head || document.documentElement).appendChild(st);

  /* ---------- helpers ---------- */
  function norm(s) { return " " + String(s || "").toUpperCase().replace(/[^A-Z0-9]+/g, " ").trim() + " "; }
  function splitKw(list) {
    var out = [];
    [].concat(list || []).forEach(function (k) { String(k || "").split(/\s*[·•,;|]\s*/).forEach(function (x) { if (x.trim()) out.push(x.trim()); }); });
    return out;
  }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function cells(line) { return String(line).replace(/\\/g, "").split(/\s*[|\t]\s*/).map(function (x) { return x.trim(); }); }
  function same(a, b) { return norm(a) === norm(b); }
  function nice(s) { s = String(s || "").trim(); return s === s.toUpperCase() ? s.toLowerCase().replace(/(^|[\s(/-])[a-z]/g, function (m) { return m.toUpperCase(); }) : s; }
  function conv(txt, from, to) {
    if (from === to) return txt;
    return String(txt).replace(/\d+(?:[.,]\d+)?/g, function (n) {
      var v = parseFloat(n.replace(",", "."));
      v = to === "cm" ? Math.round(v * 2.54 * 10) / 10 : Math.round(v / 2.54 * 4) / 4;
      return String(v);
    });
  }

  /* ---------- the owner's charts (EZ Size chart). Every chart is { name, sub, segs: [{ name, cols, rows, unit, alt }] } ---------- */
  D.charts.forEach(function (c) {
    c.kw = splitKw(c.keywords);
    c.tib = splitKw(c.tib).map(String);
    var unit = /^\s*cm\s*$/i.test(c.unit || "") ? "cm" : "in";
    var cols = c.columns ? cells(c.columns).filter(Boolean) : [], rows = [];
    c.err = [];
    String(c.sizes || "").split(/\r?\n/).forEach(function (line, i) {
      if (!line.trim()) return;
      var r = cells(line);
      if (!cols.length) cols = r.slice(1).map(function (x, k) { return "Measure " + (k + 1); });
      if (r.length - 1 !== cols.length) c.err.push("dòng " + (i + 1) + " \"" + line.trim() + "\": có " + (r.length - 1) + " số, cột có " + cols.length);
      r.slice(1).forEach(function (x) { if (x && !/\d/.test(x)) c.err.push("dòng " + (i + 1) + ": \"" + x + "\" không phải số"); });
      rows.push(r);
    });
    if (!rows.length) c.err.push("chưa nhập Sizes");
    if (!c.kw.length && !c.tib.length) c.err.push("chưa có Keywords hoặc Teeinblue IDs nên không sản phẩm nào dùng được");
    c.segs = [{ name: "", cols: cols, rows: rows, unit: unit, alt: null }];
  });
  var CHARTS = D.charts.filter(function (c) { return c.segs[0].rows.length; });

  /* ---------- Ban-63: the printer's own table inside a Teeinblue base description ----------
     Printbelle writes: row 1 the measures (each over two columns), row 2 "Unit | Inch | Cm | Inch | Cm…", then one row
     per size. A second size column ("TOP SIZE … | | BOTTOM SIZE …") starts a second table (pajama sets). Anything
     that does not look like that is ignored (no chart rather than a wrong one). */
  var AUTO = {};
  var BODY = /bust|chest|waist|hip|sleeve|shoulder|crotch|inseam|rise|neck|thigh|armhole/i;
  function measureName(h) {
    h = String(h || "").replace(/\s*\([A-Z]\)\s*$/i, "").trim();
    if (/^1\/2\s*(BUST|CHEST)$/i.test(h)) return "Chest width";
    return nice(h);
  }
  function grid(tr) {
    var out = [];
    Array.prototype.forEach.call(tr.cells, function (td) {
      var n = Math.max(1, Math.min(10, parseInt(td.getAttribute("colspan"), 10) || 1)), t = td.textContent.replace(/\s+/g, " ").trim();
      for (var i = 0; i < n; i++) out.push(t);
    });
    return out;
  }
  function parseSupplier(html) {
    if (!html || html.indexOf("<table") < 0) return null;
    var doc;
    try { doc = new DOMParser().parseFromString(html, "text/html"); } catch (e) { return null; }
    var tb = doc.querySelector("table");
    if (!tb || tb.rows.length < 4) return null;
    var head = grid(tb.rows[0]), unit = grid(tb.rows[1]);
    if (!/^unit/i.test(unit[0] || "")) return null;
    if (!head.some(function (h) { return BODY.test(h); })) return null;   // Ban-69: an object's dimensions, not a size chart
    var starts = [];
    unit.forEach(function (u, j) { if (/^unit/i.test(u)) starts.push(j); });
    var segs = [];
    starts.forEach(function (s, k) {
      var end = k + 1 < starts.length ? starts[k + 1] : unit.length, cols = [], ci = [], cc = [];
      for (var j = s + 1; j < end; j++) {
        if (/^inch/i.test(unit[j])) { cols.push(measureName(head[j])); ci.push(j); cc.push(/^cm/i.test(unit[j + 1] || "") && head[j + 1] === head[j] ? j + 1 : -1); }
      }
      if (!cols.length) return;
      var rows = [], alt = [], okRows = true;
      for (var r = 2; r < tb.rows.length; r++) {
        var g = grid(tb.rows[r]), size = g[s];
        if (!size) continue;
        var ins = ci.map(function (j) { return g[j] || ""; });
        if (!ins.every(function (x) { return /\d/.test(x); })) { okRows = false; break; }
        rows.push([size].concat(ins));
        alt.push([size].concat(cc.map(function (j, i) { return j >= 0 && /\d/.test(g[j] || "") ? g[j] : conv(ins[i], "in", "cm"); })));
      }
      if (!okRows || rows.length < 2) return;
      var nm = String(head[s] || "").replace(/\b(US\s*)?SIZE\b/i, "").trim();
      segs.push({ name: nm ? nice(nm) : "", cols: cols, rows: rows, unit: "in", alt: alt });
    });
    return segs.length ? segs : null;
  }
  /* "V4 Pajama Pants" → "Pajama Pants", "V3 Lapel Pajama Set Long (Button)" → "Lapel Pajama Set Long" */
  function cleanName(t) {
    t = String(t || "").replace(/\s*\([^)]*\)\s*/g, " ").replace(/^\s*V\d+\b\s*/i, "").replace(/\s+-\s+.*$/, "").replace(/\s+/g, " ").trim();
    return nice(t) || "Size chart";
  }
  function autoChart(b) {
    if (!b || !b.segs) return null;
    if (!AUTO[b.id]) AUTO[b.id] = { id: "auto-" + b.id, name: cleanName(b.label || b.title), auto: true, segs: b.segs, note: "", image: null };
    return AUTO[b.id];
  }

  /* ---------- which chart for which variant ---------- */
  function variantId() {
    var v = new URLSearchParams(location.search).get("variant");
    if (v && D.product.variants[v]) return v;
    var inp = document.querySelector('form[action*="/cart/add"] [name="id"]');
    return String((inp && inp.value) || D.product.variant || "");
  }
  function best(text) {
    var hay = norm(text), top = null, len = 0;
    CHARTS.forEach(function (c) {
      c.kw.forEach(function (k) { var n = norm(k); if (n.length > 3 && hay.indexOf(n) >= 0 && n.length > len) { top = c; len = n.length; } });
    });
    return top;
  }
  function chartOfBase(b) {
    for (var i = 0; i < CHARTS.length; i++) if (CHARTS[i].tib.indexOf(String(b.id)) >= 0) return { c: CHARTS[i], how: "Teeinblue ID " + b.id, base: b, byId: true };
    var c = best(b.label + " | " + b.title);
    if (c) return { c: c, how: "từ khóa trong tên base", base: b };
    var a = autoChart(b);
    return { c: a, how: a ? "bảng của nhà in (tự động)" : "", base: b, isAuto: !!a };
  }
  function chartFor(vid) {
    var b = TEE && TEE[vid];
    if (b) return chartOfBase(b);
    var v = D.product.variants[vid];
    if (TEE_STATE === "đang đọc" || TEE_STATE === "chờ") return { c: null, how: "", base: null, wait: true };
    var c2 = v ? best(v[0]) : null;
    return { c: c2, how: c2 ? "từ khóa trong \"" + v[0] + "\"" : "", base: null };
  }
  function baseOf(p) {
    return { id: p.id, title: p.title || "", label: p.label || "", segs: parseSupplier(p.description) };
  }

  /* Teeinblue campaign data (same address as Teeinblue's own request → from the browser cache) */
  var TEE = null, TEE_STATE = "chưa đọc", teeTries = 0;
  function teeUrl() {
    if (!window.performance || !performance.getEntriesByType) return null;
    var re = new RegExp("api\\.teeinblue\\.com/api/merchant/campaigns/" + D.product.id + "\\.json"), e = performance.getEntriesByType("resource"), i;
    for (i = e.length - 1; i >= 0; i--) if (re.test(e[i].name)) return e[i].name;
    return null;
  }
  function loadTee() {
    if (TEE || TEE_STATE === "đang đọc") return;
    var url = teeUrl();
    if (!url) {
      /* Ban-63: look every 150 ms (was 500) so the button shows as soon as Teeinblue has its data; ~4 s at most */
      if (++teeTries < 27) { TEE_STATE = "chờ"; setTimeout(loadTee, 150); return; }
      var shop = window.Shopify && window.Shopify.shop, c = window.teeinblueCampaign;
      if (!shop || !(c && (c.isTeeInBlueProduct || c.isPlatformProduct))) { TEE_STATE = "không phải sản phẩm Teeinblue"; refresh(); return; }
      url = "https://api.teeinblue.com/api/merchant/campaigns/" + D.product.id + ".json?shop=" + encodeURIComponent(shop);
    }
    TEE_STATE = "đang đọc";
    fetch(url, { credentials: "omit" }).then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); }).then(function (j) {
      var cv = {}, map = {}, n = 0, byId = {};
      (j.campaign_products || []).forEach(function (cp) {
        var p = cp.product || {}, b = byId[p.id] || (byId[p.id] = baseOf(p));
        (cp.campaign_variants || []).forEach(function (v) { cv[String(v.variant_id)] = b; });
      });
      (j.instance_variants || []).forEach(function (iv) { var b = cv[String(iv.variant_id)]; if (b) { map[String(iv.platform_linked_id)] = b; n++; } });
      TEE = n ? map : null; TEE_STATE = n ? "đã đọc" : "dữ liệu Teeinblue không có biến thể";
      refresh();
    }).catch(function () { TEE_STATE = "không đọc được dữ liệu Teeinblue"; refresh(); });
  }

  /* ---------- unit ---------- */
  function startUnit() {
    try { var s = localStorage.getItem("ezSizeUnit"); if (s === "in" || s === "cm") return s; } catch (e) {}
    var c = (qs.get("ez_country") || (window.Shopify && window.Shopify.country) || D.country || "US").toUpperCase();
    return c === "US" ? "in" : "cm";
  }
  var UNIT = startUnit();

  /* the styles of this product that have a chart (chips), in the order of the variants */
  function styles() {
    var seen = {}, out = [];
    Object.keys(D.product.variants).forEach(function (vid) {
      var ap = D.product.variants[vid][0] || "";
      if (seen[ap]) return;
      seen[ap] = 1;
      var r = chartFor(vid);
      if (r.c && !out.some(function (x) { return x.c === r.c; })) out.push({ label: ap, c: r.c });
    });
    return out;
  }

  /* ---------- the popup: built once, then only classes change ---------- */
  var ICON_X = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M3.5 3.5l9 9M12.5 3.5l-9 9"/></svg>';
  var ICON_I = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><circle cx="8" cy="8" r="6.5"/><path d="M8 7.2v4M8 4.8v.01" stroke-linecap="round"/></svg>';
  var ICON_R = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><rect x="1.5" y="5" width="13" height="6" rx="1"/><path d="M4.5 5v2M7 5v3M9.5 5v2M12 5v3"/></svg>';
  var ICON_T = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round" aria-hidden="true"><path d="M5.5 2.5 2 4.5l1.3 2.6 1.4-.6V13.5h6.6V6.5l1.4.6L14 4.5l-3.5-2c-.4 1-1.4 1.6-2.5 1.6S5.9 3.5 5.5 2.5z"/></svg>';
  var ICON_V = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 6l4 4 4-4"/></svg>';
  var SH = null;   /* { box, card, body, list, built } */

  function val(txt, from, to, given) { return given != null ? given : conv(txt, from, to); }
  /* one column reads the same way: if any value has a decimal, all of them show one ("25" next to "26.7" → "25.0") */
  function tidyCol(vals) {
    var dec = vals.some(function (v) { return /\d[.,]\d/.test(v); });
    return vals.map(function (v) {
      return String(v).replace(/\d+(?:[.,]\d+)?/g, function (n) { var x = parseFloat(n.replace(",", ".")); return dec ? (Math.round(x * 10) / 10).toFixed(1) : String(Math.round(x * 100) / 100); });
    });
  }
  function segHtml(s) {
    var other = s.unit === "in" ? "cm" : "in", h = "", n = s.cols.length, inC = [], cmC = [];
    for (var i = 1; i <= n; i++) {
      var a = [], b = [];
      s.rows.forEach(function (r, ri) {
        var v = r[i] || "", w = val(v, s.unit, other, s.alt && s.alt[ri] ? s.alt[ri][i] : null);
        a.push(s.unit === "in" ? v : w); b.push(s.unit === "in" ? w : v);
      });
      inC.push(tidyCol(a)); cmC.push(tidyCol(b));
    }
    if (s.name) h += '<p class="ez-sgs__seg">' + esc(s.name) + "</p>";
    var first = n > 3 ? 18 : 22;
    h += '<div class="ez-sgs__wrap"><table class="ez-sgs__tbl"><colgroup><col style="width:' + first + '%">';
    for (i = 0; i < n; i++) h += "<col>";
    h += '</colgroup><thead><tr><th scope="col">Size</th>';
    s.cols.forEach(function (x) { h += '<th scope="col">' + esc(x) + "</th>"; });
    h += "</tr></thead><tbody>";
    s.rows.forEach(function (r, ri) {
      h += '<tr data-size="' + esc(norm(r[0])) + '"><th scope="row">' + esc(r[0]) + "</th>";
      for (var k = 0; k < n; k++) h += '<td><span class="ez-i">' + esc(inC[k][ri]) + '</span><span class="ez-c">' + esc(cmC[k][ri]) + "</span></td>";
      h += "</tr>";
    });
    return h + "</tbody></table></div>";
  }
  function panelHtml(c, i) {
    var h = '<div class="ez-sgs__panel" data-i="' + i + '" role="tabpanel">';
    c.segs.forEach(function (s) { h += segHtml(s); });
    /* the owner's note on its own line, without any sentence about tolerance (ours says it, in the unit shown) */
    var tip = (String(c.note || "").match(/[^.!?]+[.!?]*/g) || []).filter(function (x) { return x.trim() && !/\bvar(y|ies)\b|±|tolerance/i.test(x); }).join(" ").trim();
    h += '<div class="ez-sgs__notes"><p class="ez-sgs__note">' + ICON_I + '<span><span class="ez-i">Measured flat. Sizes may vary by ±1 in.</span>' +
      '<span class="ez-c">Measured flat. Sizes may vary by ±2.5 cm.</span></span></p>' +
      (tip ? '<p class="ez-sgs__note ez-sgs__tip">' + ICON_T + "<span>" + esc(tip) + "</span></p>" : "") + "</div>";
    if (c.image) h += '<details class="ez-sgs__how"><summary>How to measure' + ICON_V + '</summary><img src="' + esc(c.image) + '" alt="How to measure: ' + esc(c.name) + '" width="900" height="600" decoding="async"></details>';
    return h + "</div>";
  }
  function build() {
    if (SH && SH.built) return SH;
    var list = styles();
    if (!list.length) return null;
    var box = SH && SH.box;
    if (!box) {
      box = document.createElement("div");
      box.className = "ez-sgs" + (UNIT === "cm" ? " is-cm" : "");
      box.setAttribute("role", "dialog");
      box.setAttribute("aria-modal", "true");
      box.setAttribute("aria-labelledby", "ezSgsT");
    }
    var h = '<div class="ez-sgs__bg"></div><div class="ez-sgs__card" tabindex="-1">' +
      '<div class="ez-sgs__head"><h2 class="ez-sgs__t" id="ezSgsT">Size guide</h2>' +
      (list.length === 1 && list[0].label ? '<p class="ez-sgs__sub">' + esc(nice(list[0].label)) + "</p>" : "") +
      '<span class="ez-sgs__x" tabindex="0" aria-label="Close">' + ICON_X + "</span></div>" +
      '<div class="ez-sgs__body">';
    if (list.length > 1) {
      h += '<div class="ez-sgs__chips" role="tablist" aria-label="Style">';
      list.forEach(function (s, i) { h += '<span class="ez-sgs__chip" role="tab" tabindex="0" data-i="' + i + '" aria-selected="false">' + esc(nice(s.label)) + "</span>"; });
      h += "</div>";
    }
    /* Ban-66: no chart name here (the owner's entry name, e.g. "Unisex T-Shirt", is not what the customer chose);
       the chip already says which style is shown */
    h += '<div class="ez-sgs__bar"><p class="ez-sgs__cap">' + ICON_R + '<span class="ez-i">All measurements in inches</span><span class="ez-c">All measurements in cm</span></p>' +
      '<div class="ez-sgs__unit" role="radiogroup" aria-label="Unit">' +
      '<span role="radio" tabindex="0" data-u="in" aria-checked="false">inches</span><span role="radio" tabindex="0" data-u="cm" aria-checked="false">cm</span></div></div><div class="ez-sgs__panels">';
    list.forEach(function (s, i) { h += panelHtml(s.c, i); });
    h += "</div></div></div>";
    box.innerHTML = h;
    if (!box.parentNode) document.body.appendChild(box);
    SH = { box: box, card: box.querySelector(".ez-sgs__card"), body: box.querySelector(".ez-sgs__body"), panels: box.querySelector(".ez-sgs__panels"), list: list, built: true, cur: -1 };
    wire(SH);
    sizes(SH);
    Array.prototype.forEach.call(box.querySelectorAll("[data-u]"), function (x) { x.setAttribute("aria-checked", String(x.dataset.u === UNIT)); });
    return SH;
  }
  function show(i, size, anim) {
    var s = SH;
    s.cur = i;
    Array.prototype.forEach.call(s.box.querySelectorAll(".ez-sgs__panel"), function (p) { p.classList.toggle("is-on", +p.dataset.i === i); });
    var chipOn = null;
    Array.prototype.forEach.call(s.box.querySelectorAll(".ez-sgs__chip"), function (b) { var on = +b.dataset.i === i; b.setAttribute("aria-selected", String(on)); if (on) chipOn = b; });
    /* the chosen style's chip in view (no smooth scroll on opening: it is already in place when the sheet arrives) */
    /* Ban-66: positions and heights come from what ResizeObserver measured earlier (sizes()), never measured here */
    var cx = chipOn && s.chipX && s.chipX[i];
    if (cx) { var row = chipOn.parentNode, x = Math.max(0, cx[0] - (s.rowW - cx[1]) / 2); if (anim && row.scrollTo) row.scrollTo({ left: x, behavior: "smooth" }); else row.scrollLeft = x; }
    setHeight(anim);
    Array.prototype.forEach.call(s.box.querySelectorAll(".ez-sgs__name > span"), function (n) { n.classList.toggle("is-on", +n.dataset.i === i); });
    var key = size && i === s.home ? norm(size) : null;   /* the chosen size only in the chosen style's table */
    Array.prototype.forEach.call(s.box.querySelectorAll("tr[data-size]"), function (tr) { tr.classList.toggle("is-on", !!key && tr.dataset.size === key && tr.closest(".ez-sgs__panel").dataset.i === String(i)); });
  }
  /* the box takes the height of the table shown, gliding from one to the other (no empty space under a short table) */
  function setHeight(anim) {
    var s = SH, h = s && s.h && s.h[s.cur];
    if (!h) return;
    var panels = s.panels;
    if (!anim) { panels.style.transition = "none"; panels.style.height = h + "px"; requestAnimationFrame(function () { panels.style.transition = ""; }); }
    else panels.style.height = h + "px";
  }
  /* sizes are read by ResizeObserver, right after the browser has laid the popup out anyway (no extra work) */
  function sizes(s) {
    s.h = {}; s.chipX = {};
    if (!window.ResizeObserver) return;
    var ro = new ResizeObserver(function () {
      Array.prototype.forEach.call(s.box.querySelectorAll(".ez-sgs__panel"), function (p) { s.h[+p.dataset.i] = p.offsetHeight; });
      var row = s.box.querySelector(".ez-sgs__chips");
      if (row) { s.rowW = row.clientWidth; Array.prototype.forEach.call(row.children, function (c) { s.chipX[+c.dataset.i] = [c.offsetLeft, c.offsetWidth]; }); }
      if (s.cur >= 0) setHeight(isOpen);
    });
    Array.prototype.forEach.call(s.box.querySelectorAll(".ez-sgs__panel, .ez-sgs__chips"), function (x) { ro.observe(x); });
  }
  function setUnit(u) {
    UNIT = u;
    try { localStorage.setItem("ezSizeUnit", u); } catch (e) {}
    if (SH) {
      SH.box.classList.toggle("is-cm", u === "cm");
      Array.prototype.forEach.call(SH.box.querySelectorAll("[data-u]"), function (x) { x.setAttribute("aria-checked", String(x.dataset.u === u)); });
    }
  }

  var lastFocus = null, isOpen = false, pushed = false, curSize = "";
  var IOS = /iP(hone|ad|od)/.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
  function open() {
    var vid = variantId(), r = chartFor(vid);
    if (!r.c || !build()) return;
    var i = -1;
    SH.list.forEach(function (x, k) { if (x.c === r.c) i = k; });
    if (i < 0) { SH.built = false; if (!build()) return; SH.list.forEach(function (x, k) { if (x.c === r.c) i = k; }); }
    curSize = (D.product.variants[vid] || [])[1] || "";
    SH.home = Math.max(0, i);
    show(Math.max(0, i), curSize, false);
    SH.body.scrollTop = 0;
    lastFocus = document.activeElement;
    isOpen = true;
    SH.box.classList.add("is-open");
    /* Ban-72: on iPhone the extra history step made Safari bring its toolbar back, which nudged the sheet up once it
       had slid in; iPhone has no Back button to close it with anyway, so the step is only added elsewhere (Android) */
    if (!IOS) { try { history.pushState({ ezSgs: 1 }, ""); pushed = true; } catch (e) { pushed = false; } }
    setTimeout(function () { try { SH.card.focus({ preventScroll: true }); } catch (e) {} }, 60);
  }
  function close(fromHistory) {
    if (!isOpen || !SH) return;
    isOpen = false;
    SH.box.classList.remove("is-open");
    SH.card.style.transition = ""; SH.card.style.transform = "";
    if (pushed && !fromHistory && history.state && history.state.ezSgs) { try { history.back(); } catch (e) {} }
    pushed = false;
    if (lastFocus && lastFocus.focus && document.contains(lastFocus)) try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
  }
  window.addEventListener("popstate", function () { if (isOpen) close(true); });

  function wire(s) {
    var box = s.box, card = s.card, body = s.body, bg = box.querySelector(".ez-sgs__bg");
    if (box.__ezWired) return;
    box.__ezWired = true;
    box.addEventListener("pointerdown", function () { box.classList.remove("is-kbd"); });
    box.addEventListener("keydown", function (e) {
      if ((e.key === "Enter" || e.key === " ") && e.target.matches && e.target.matches(".ez-sgs__x, .ez-sgs__chip, [data-u]")) { e.preventDefault(); e.target.click(); }
    });
    document.addEventListener("keydown", function (e) {
      if (!isOpen) return;
      if (e.key === "Tab") box.classList.add("is-kbd");
      if (e.key === "Escape") { e.preventDefault(); close(false); return; }
      if (e.key !== "Tab") return;
      var f = Array.prototype.filter.call(card.querySelectorAll("[tabindex='0'], summary"), function (x) { return x.offsetParent !== null && !x.closest(".ez-sgs__panel:not(.is-on)"); });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === card)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    /* the page behind never scrolls: touches on the backdrop or the head are held; the body scrolls on its own */
    bg.addEventListener("touchmove", function (e) { if (e.cancelable) e.preventDefault(); }, { passive: false });
    box.addEventListener("wheel", function (e) {
      if (!isOpen) return;
      var inBody = body.contains(e.target), up = e.deltaY < 0;
      if (!inBody || (up ? body.scrollTop <= 0 : body.scrollTop + body.clientHeight >= body.scrollHeight - 1)) e.preventDefault();
    }, { passive: false });

    /* phones: pull the sheet down to close (follows the finger; past a quarter of its height or a quick flick) */
    var g = null;
    function atBottom() { var r = card.getBoundingClientRect(); return r.bottom >= window.innerHeight - 2 && r.left <= 1; }
    card.addEventListener("touchstart", function (e) {
      g = null;
      if (!isOpen || e.touches.length !== 1 || !atBottom()) return;
      if (e.target.closest(".ez-sgs__chips, .ez-sgs__x")) return;
      var p = e.touches[0];
      g = { x0: p.clientX, y0: p.clientY, y1: 0, dy: 0, mode: 0, h: card.offsetHeight, ly: p.clientY, lt: e.timeStamp, v: 0, inBody: body.contains(e.target) };
    }, { passive: true });
    card.addEventListener("touchmove", function (e) {
      if (!g) return;
      var p = e.touches[0], dx = p.clientX - g.x0, dy = p.clientY - g.y0;
      if (g.mode === 0) {
        if (g.inBody && body.scrollTop > 0) { g = null; return; }
        if (dy > 0 && Math.abs(dy) >= Math.abs(dx) && e.cancelable) e.preventDefault();
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
        if (dy <= 0 || Math.abs(dx) > Math.abs(dy)) { if (!g.inBody && e.cancelable) e.preventDefault(); g = null; return; }
        g.mode = 1; g.y1 = p.clientY;
        card.style.transition = "none";
        bg.style.transition = "none";
      }
      if (e.cancelable) e.preventDefault();
      var d = p.clientY - g.y1;
      d = d < 0 ? d / 5 : d;
      g.dy = d;
      var dt = e.timeStamp - g.lt;
      if (dt > 0) { g.v = (p.clientY - g.ly) / dt; g.ly = p.clientY; g.lt = e.timeStamp; }
      card.style.transform = "translate3d(0," + Math.round(d) + "px,0)";
      bg.style.opacity = String(Math.max(0, 1 - Math.max(0, d) / g.h));
    }, { passive: false });
    function end() {
      var s0 = g; g = null;
      if (!s0 || s0.mode !== 1) return;
      card.style.transition = ""; bg.style.transition = ""; bg.style.opacity = "";
      if (s0.dy > s0.h * 0.25 || (s0.v > 0.45 && s0.dy > 20)) { card.style.transform = ""; close(false); }
      else {
        card.style.transition = "transform .3s cubic-bezier(.2, .9, .25, 1)";
        card.style.transform = "translate3d(0,0,0)";
        setTimeout(function () { if (isOpen) { card.style.transition = ""; card.style.transform = ""; } }, 320);
      }
    }
    card.addEventListener("touchend", end);
    card.addEventListener("touchcancel", end);
  }
  /* Ban-66: every click on the "Size guide" link or inside the popup is handled here, on the window in the capture
     phase, and stops here. Facebook Pixel listens to all clicks on the document and spent 57–182 ms per click on this
     page reading what is around the clicked element (the mouse stalled); it now never sees these clicks, nor does
     anything else. "How to measure" still opens: stopping an event does not cancel what the browser does with it. */
  window.addEventListener("click", function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var trig = t.closest(".ez-sg-btn"), box = t.closest(".ez-sgs");
    if (!trig && !box) return;
    e.stopImmediatePropagation();
    if (trig) { e.preventDefault(); open(); return; }
    if (!SH || box !== SH.box) return;
    if (t.classList.contains("ez-sgs__bg") || t.closest(".ez-sgs__x")) { e.preventDefault(); close(false); return; }
    var b = t.closest("[data-u], .ez-sgs__chip");
    if (!b) return;
    e.preventDefault();
    if (b.dataset.u) setUnit(b.dataset.u);
    else show(+b.dataset.i, curSize, true);
  }, true);
  function idle(fn) { (window.requestIdleCallback || function (f) { return setTimeout(f, 200); })(fn, { timeout: 2000 }); }

  /* ---------- the button after the Size title ---------- */
  var RULER = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><rect x="2.5" y="7.5" width="19" height="9" rx="1.5"/><path d="M6.5 7.5v3M10 7.5v4.5M13.5 7.5v3M17 7.5v4.5"/></svg>';
  function sizeTitle() {
    var t = document.querySelector(".tee-option--size .tee-option__title");
    if (t) return t;
    var all = document.querySelectorAll(".tee-option__title"), i;
    for (i = 0; i < all.length; i++) if (/^\s*(choose your )?size\b/i.test(all[i].textContent)) return all[i];
    return null;
  }
  var prepared = false;
  function place() {
    var r = chartFor(variantId()), t = sizeTitle(), old = document.querySelectorAll(".ez-sg-btn");
    var want = r.c && t;
    Array.prototype.forEach.call(old, function (b) { if (!want || b.parentNode !== t) b.remove(); });
    if (want && !prepared) { prepared = true; idle(build); }   /* the popup is ready before the first tap */
    if (!want || t.querySelector(".ez-sg-btn")) return;
    t.classList.add("ez-sg-host");
    /* Ban-65: not a <button>. Facebook Pixel's automatic events record every click on a <button> / role="button"
       (even with propagation stopped) by building a hidden ~300-field form and posting it to facebook.com in a hidden
       frame: the page re-lays out and Windows shows the busy cursor for a moment. A link-like element is left alone. */
    var b = document.createElement("span");
    b.className = "ez-sg-btn";
    b.setAttribute("role", "link");
    b.setAttribute("tabindex", "0");
    b.setAttribute("aria-haspopup", "dialog");
    b.addEventListener("keydown", function (e) { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); open(); } });
    b.innerHTML = RULER + "<span>Size guide</span>";
    t.appendChild(b);
  }

  /* ---------- owner's check (this product) ---------- */
  function check() {
    if (!CHECK) return;
    var p = document.querySelector(".ez-sg-check");
    if (!p) { p = document.createElement("div"); p.className = "ez-sg-check"; document.body.appendChild(p); }
    var h = "<b>Kiểm tra bảng size (Ban-66)</b> · dữ liệu Teeinblue: " + esc(TEE_STATE) + "<br>";
    h += "Bảng đã nhập: " + D.charts.length + " (" + CHARTS.length + " dùng được)<ul>";
    D.charts.forEach(function (c) {
      var s = c.segs[0];
      h += "<li>" + esc(c.name || c.id) + ": " + s.rows.length + " size, cột " + esc(s.cols.join(" / ")) + " (" + s.unit + ")" +
        (c.err.length ? '<br><span class="bad">' + c.err.map(esc).join("<br>") + "</span>" : "") + "</li>";
    });
    h += "</ul>Sản phẩm này:<ul>";
    var seen = {};
    Object.keys(D.product.variants).forEach(function (vid) {
      var ap = D.product.variants[vid][0] || "(không có kiểu)";
      if (seen[ap]) return; seen[ap] = 1;
      var r = chartFor(vid);
      h += "<li>" + esc(ap) + (r.base ? " → base " + esc(r.base.id) + " \"" + esc(r.base.label || r.base.title) + "\"" : "") + ": " +
        (r.c ? "<b>" + esc(r.c.name) + "</b> (" + esc(r.how) + ")" : '<span class="bad">' + (r.wait ? "đang đọc…" : "không có bảng") + "</span>") + "</li>";
    });
    h += "</ul>Đơn vị mặc định ở nước này: " + startUnit() + " · đang chọn: " + esc((D.product.variants[variantId()] || []).join(" / "));
    p.innerHTML = h;
  }

  /* ---------- Ban-62: the whole store (?ez_size_check=all) ---------- */
  var SIZE_RE = /^(XXS|XS|S|M|L|XL|XXL|XXXL|[2-6]XL|Y(XS|S|M|L|XL)|YOUTH ?(XS|S|M|L|XL)|[0-9]{1,2}T|NB|[0-9]{1,2}-[0-9]{1,2} ?M(ONTHS)?)$/i;
  function scan() {
    var p = document.createElement("div");
    p.className = "ez-sg-check ez-sg-scan";
    document.body.appendChild(p);
    var shop = window.Shopify && window.Shopify.shop, prods = [], page = 1;
    function say(t) { p.innerHTML = "<b>Kiểm tra bảng size cả shop (Ban-66)</b><br>" + t; }
    say("Đang đọc danh sách sản phẩm…");
    function list() {
      return fetch("/products.json?limit=250&page=" + page, { credentials: "same-origin" }).then(function (r) { return r.json(); }).then(function (j) {
        var a = j.products || [];
        a.forEach(function (x) {
          var sized = (x.options || []).some(function (o) { return /size/i.test(o.name) && (o.values || []).some(function (v) { return SIZE_RE.test(String(v).trim()); }); });
          if (sized) prods.push({ id: x.id, handle: x.handle, title: x.title });
        });
        say("Đang đọc danh sách sản phẩm… trang " + page + ", " + prods.length + " sản phẩm có size quần áo");
        if (a.length === 250 && page < 40) { page++; return list(); }
      });
    }
    var bases = {}, done = 0, fail = 0;
    function one(x) {
      var url = "https://api.teeinblue.com/api/merchant/campaigns/" + x.id + ".json?shop=" + encodeURIComponent(shop);
      return fetch(url, { credentials: "omit" }).then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
        var seen = {};
        ((j && j.campaign_products) || []).forEach(function (cp) {
          var b = cp.product || {}, k = String(b.id);
          if (!b.id || seen[k]) return;
          seen[k] = 1;
          if (!bases[k]) { bases[k] = baseOf(b); bases[k].style = cp.platform_title || ""; bases[k].n = 0; bases[k].ex = x; }
          bases[k].n++;
        });
        if (!j) fail++;
      }).catch(function () { fail++; }).then(function () {
        done++;
        if (done % 10 === 0 || done === prods.length) say("Đang đọc dữ liệu Teeinblue: " + done + "/" + prods.length + " sản phẩm" + (fail ? " (" + fail + " không đọc được)" : ""));
      });
    }
    function pool() {
      var i = 0;
      function next() { if (i >= prods.length) return Promise.resolve(); var x = prods[i++]; return one(x).then(next); }
      var w = []; for (var k = 0; k < 6; k++) w.push(next());
      return Promise.all(w);
    }
    function showScan() {
      var rows = Object.keys(bases).map(function (k) { var b = bases[k], r = chartOfBase(b); return { b: b, c: r.c, how: r.how, rank: !r.c ? 0 : r.byId ? 3 : r.isAuto ? 2 : 1 }; });
      rows.sort(function (a, b) { return a.rank - b.rank || b.b.n - a.b.n; });
      var cnt = [0, 0, 0, 0]; rows.forEach(function (r) { cnt[r.rank]++; });
      var h = "<b>Kiểm tra bảng size cả shop (Ban-66)</b> · " + prods.length + " sản phẩm có size quần áo · " + rows.length + " base" + (fail ? ' · <span class="bad">' + fail + " sản phẩm không đọc được</span>" : "") +
        '<br><span class="bad">' + cnt[0] + " base chưa có bảng</span> (khách không thấy nút Size guide) · " + cnt[1] + " base nhận bảng theo từ khóa (xem lại nếu là phôi khác) · " +
        cnt[2] + " base dùng bảng của nhà in (tự động) · " + cnt[3] + " base theo Teeinblue ID" +
        ' <button type="button" class="ez-sg-csv">Tải CSV</button>' +
        '<table><thead><tr><th>Base ID</th><th>Tên base (label / title)</th><th>Kiểu</th><th>Bảng</th><th>SP</th><th>Ví dụ</th></tr></thead><tbody>';
      rows.forEach(function (r) {
        h += "<tr" + (r.c ? "" : ' class="bad"') + "><td>" + esc(r.b.id) + "</td><td>" + esc(r.b.label) + (r.b.title && r.b.title !== r.b.label ? "<br><small>" + esc(r.b.title) + "</small>" : "") + "</td><td>" + esc(r.b.style) +
          "</td><td>" + (r.c ? esc(r.c.name) + "<br><small>" + esc(r.how) + "</small>" : "chưa có bảng") + "</td><td>" + r.b.n +
          '</td><td><a href="/products/' + esc(r.b.ex.handle) + '?ez_size_check=1" target="_blank" rel="noopener">' + esc(r.b.ex.title.slice(0, 40)) + "</a></td></tr>";
      });
      p.innerHTML = h + "</tbody></table>";
      p.querySelector(".ez-sg-csv").addEventListener("click", function () {
        var q = function (v) { return '"' + String(v == null ? "" : v).replace(/"/g, '""') + '"'; };
        var csv = "﻿base_id,label,title,kieu,bang,cach_nhan,so_san_pham,vi_du\n" + rows.map(function (r) {
          return [r.b.id, r.b.label, r.b.title, r.b.style, r.c ? r.c.name : "", r.how, r.b.n, "/products/" + r.b.ex.handle].map(q).join(",");
        }).join("\n");
        var a = document.createElement("a");
        a.href = URL.createObjectURL(new Blob([csv], { type: "text/csv" }));
        a.download = "bang-size-theo-base.csv";
        document.body.appendChild(a); a.click(); a.remove();
      });
    }
    if (!shop) { say('<span class="bad">Không thấy tên shop</span>'); return; }
    list().then(function () { say("Đang đọc dữ liệu Teeinblue: 0/" + prods.length); return pool(); }).then(showScan)
      .catch(function () { say('<span class="bad">Không đọc được danh sách sản phẩm</span>'); });
  }

  /* ---------- start ---------- */
  var tm = null;
  function refresh() { place(); check(); }
  function soon() { if (tm) return; tm = setTimeout(function () { tm = null; refresh(); }, 120); }
  function start() {
    if (SCAN) { scan(); return; }
    loadTee();
    refresh();
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var n = list[i].target;
        if (n.closest && (n.closest(".ez-sgs") || n.closest(".ez-sg-check"))) continue;
        /* Ban-72: when Teeinblue redraws the Size row the link is put back before the next frame is drawn (it used
           to be missing for ~0.1 s, so the row and everything under it moved) */
        if (n.closest && n.closest("#tee-artwork-form") && !document.querySelector(".tee-option__title .ez-sg-btn")) place();
        soon(); return;
      }
    }).observe(document.body, { childList: true, subtree: true });
    window.addEventListener("popstate", soon);
    document.addEventListener("change", soon, true);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start); else start();
})();
